import { styled } from "twin.macro"

const RippleButton = styled.button(
  ({ size = 1, scale = 1.5, duration = 3, delay = 1.1 }) => {
    return `
    position: relative;
    border-radius: 9999px;
    display: block;

    &:before,
    &:after {
      content: '';
      border-color: currentColor;
      border-radius: 9999px;
      border: solid 1px;
      display: block;
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
    }
    &:before {
      animation: ripple ${duration}s linear infinite;
    }
    &:after {
      animation: ripple ${duration}s linear ${delay}s infinite;
    }
    &:hover {
      transform: scale(${scale});
      &:before,
      &:after {
        animation: none
      }
    }
    @keyframes ripple{
      0% {transform:scale(1); opacity: 0}
      75% {transform:scale(1.75); opacity:1;}
      100% {transform:scale(2); opacity:0;}
    }
  `
  }
)

export default RippleButton
